"use strict";
/**
 * Composed APIs
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
// Cluster
__exportStar(require("./composed/cluster/createCluster"), exports);
__exportStar(require("./composed/cluster/transferCluster"), exports);
// Spore
__exportStar(require("./composed/spore/createSpore"), exports);
__exportStar(require("./composed/spore/transferSpore"), exports);
__exportStar(require("./composed/spore/meltSpore"), exports);
// ClusterProxy
__exportStar(require("./composed/clusterProxy/createClusterProxy"), exports);
__exportStar(require("./composed/clusterProxy/transferClusterProxy"), exports);
__exportStar(require("./composed/clusterProxy/meltClusterProxy"), exports);
// ClusterAgent
__exportStar(require("./composed/clusterAgent/createClusterAgent"), exports);
__exportStar(require("./composed/clusterAgent/transferClusterAgent"), exports);
__exportStar(require("./composed/clusterAgent/meltClusterAgent"), exports);
// Mutant
__exportStar(require("./composed/mutant/createMutant"), exports);
__exportStar(require("./composed/mutant/transferMutant"), exports);
/**
 * Joint APIs
 */
// Cluster
__exportStar(require("./joints/cluster/injectNewClusterOutput"), exports);
__exportStar(require("./joints/cluster/injectNewClusterIds"), exports);
__exportStar(require("./joints/cluster/injectLiveClusterCell"), exports);
__exportStar(require("./joints/cluster/injectLiveClusterReference"), exports);
__exportStar(require("./joints/cluster/getCluster"), exports);
// Spore
__exportStar(require("./joints/spore/injectNewSporeOutput"), exports);
__exportStar(require("./joints/spore/injectLiveSporeCell"), exports);
__exportStar(require("./joints/spore/injectNewSporeIds"), exports);
__exportStar(require("./joints/spore/getSpore"), exports);
// ClusterProxy
__exportStar(require("./joints/clusterProxy/injectNewClusterProxyOutput"), exports);
__exportStar(require("./joints/clusterProxy/injectNewClusterProxyIds"), exports);
__exportStar(require("./joints/clusterProxy/injectLiveClusterProxyCell"), exports);
__exportStar(require("./joints/clusterProxy/injectLiveClusterProxyReference"), exports);
__exportStar(require("./joints/clusterProxy/getClusterProxy"), exports);
// ClusterAgent
__exportStar(require("./joints/clusterAgent/injectNewClusterAgentOutput"), exports);
__exportStar(require("./joints/clusterAgent/injectLiveClusterAgentCell"), exports);
__exportStar(require("./joints/clusterAgent/injectLiveClusterAgentReference"), exports);
__exportStar(require("./joints/clusterAgent/getClusterAgent"), exports);
// Mutant
__exportStar(require("./joints/mutant/injectNewMutantOutput"), exports);
__exportStar(require("./joints/mutant/injectNewMutantIds"), exports);
__exportStar(require("./joints/mutant/injectLiveMutantCell"), exports);
__exportStar(require("./joints/mutant/injectLiveMutantReferences"), exports);
__exportStar(require("./joints/mutant/getMutant"), exports);
//# sourceMappingURL=index.js.map